import { combineReducers } from "redux";
import { formReducer } from "./authorize";

export default combineReducers({
  formReducer
});
